import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handleApiErrors } from "../../Utils/Utils";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, validationRegex } from "../../Utils/Utils";
import * as yup from "yup";
import * as XLSX from 'xlsx';
import DataProvider from "../../Utils/DataProvider";
import 'react-datepicker/dist/react-datepicker.css';
import Calanderimg from '../../assets/images/png/fi_12671954.png'
import DatePicker from "react-datepicker";
import CoordinatorService from "../../Services/CoordinatorService";
import FormModal from "../../Components/modal/FormModal";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { AuthContext } from "../../Context/authContext";

const CoordinatorPayout = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [offset, setOffset] = useState(0);
    const [offset2, setOffset2] = useState(0);
    const [limit, setLimit] = useState(10);
    const [limit2, setLimit2] = useState(10);
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [availableDataCount2, setAvailableDataCount2] = useState(0);
    const [coordinators, setCoordinators] = useState({});
    const [Withdrawl, setWithdrawl] = useState([]);
    const [transactiondata, setTransactionData] = useState([]);
    const [requestid, setRequestId] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [requestamount, setRequestAmount] = useState('');
    const { id } = useParams();
    const { user } = useContext(AuthContext)


    const navigate = useNavigate();

    const stepOneValidations = yup.object().shape({
        amount: validationRegex.required,
        transactionid: validationRegex.required,
        modeofpayment: validationRegex.required
    });

    const { register: registerStepOne, handleSubmit: handleSubmitAdd, setValue: setValuesStepOne, formState: { errors: errorsStepOne }, reset } = useForm({
        resolver: yupResolver(stepOneValidations),
        defaultValues: {
            amount: "",
            transactionid: "",
            modeofpayment: "Bank Transfer"
        },
    });

    const handleStartDateChange = (date) => setStartDate(date);
    const handleEndDateChange = (date) => setEndDate(date);

    const CustomDateInput = ({ value, onClick }) => (
        <div className="custom-date-input" onClick={onClick}>
            <input
                type="text"
                placeholder="From"
                value={value}
                readOnly
                className="form-control"
            />
            <img src={Calanderimg} alt="" className="calendar-icon" />
        </div>
    );
    const CustomDateInputTo = ({ value, onClick }) => (
        <div className="custom-date-input" onClick={onClick}>
            <input
                type="text"
                placeholder="To"
                value={value}
                readOnly
                className="form-control"
            />
            <img src={Calanderimg} alt="" className="calendar-icon" />
        </div>
    );

    const getAllCoordinatorWithdrawlRequest = async (data) => {
        try {
            const response = await CoordinatorService.getAllCoordinatorWithdrawlRequest(
                offset,
                limit,
                data.coordinatorId,
            );
            setWithdrawl(response.data);
            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };
    const transactionHistory = async (id) => {
        try {
            const response = await CoordinatorService.transactionHistory(
                id,
                offset2,
                limit2,
                startDate,
                endDate
            );
            setTransactionData(response.data);
            setAvailableDataCount2(response.availableDataCount);
            if (offset2 != 0 && offset2 * limit2 > availableDataCount2 - 1) {
                setOffset2(offset2 - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        }
    };
    const Paynow = async (data) => {
        if (data.amount > requestamount) {
            toast.error("Your amount is not more than Request Amount!")
            return;
        }
        try {
            const response = await CoordinatorService.withdrwalRequest(
                requestid,
                data.amount,
                data.modeofpayment,
                data.transactionid
            );
            reset();
            setShowAddModal(false)
            toast.success("Payment Successfull");
            getAllCoordinatorWithdrawlRequest();
            // transactionHistory()
            window.location.reload();
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const getAllCoordinatorRequest = async (id) => {

        try {
            const response = await CoordinatorService.getAllCoordinatorRequest(id);
            setCoordinators(response.data);
        } catch (error) {
            handleApiErrors(error);
        }
    };

    useEffect(() => {
        if (id) {
            getAllCoordinatorWithdrawlRequest({ coordinatorId: id });
        }
    }, [id, offset]);



    useEffect(() => {
        if (id) {
            getAllCoordinatorRequest(id);
            transactionHistory(id);
        }
    }, [id, offset, limit, offset2, limit2]);

    useEffect(() => {
        const fetchTransactionsByDate = () => {
            if (startDate || endDate) {
                transactionHistory(id, startDate, endDate);
            }
        };

        const timeoutId = setTimeout(fetchTransactionsByDate, 500); // Debounce the request

        return () => clearTimeout(timeoutId); // Clear timeout if date changes again quickly
    }, [startDate, endDate]);

    const removeTimeFromDate = (dateString) => {
        if (!dateString) return '';
        const dateObject = new Date(dateString);
        // Ensure the date is parsed as UTC
        const utcYear = dateObject.getUTCFullYear();
        const utcMonth = dateObject.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
        const utcDay = dateObject.getUTCDate();
        return `${utcDay} ${utcMonth} , ${utcYear}`;

    };

    const exportToExcel = (data, fileName) => {
        if (!data || data.length === 0) {
            toast.info("No data to export");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, fileName);

    };
    const handleExportClick = () => {
        const coordinatorName = coordinators.coordinatorName || "Coordinator";
        const fileName = `${coordinatorName} Transaction History.xlsx`;
        exportToExcel(transactiondata, fileName);
    };

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between">
                <h1 className="black fs-18 fw-600 mb-0">Payout</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">coordinators</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <h1 className="black fs-18 fw-600 mb-0">Coordinator Details</h1>
                <div className="table_title ps-2">
                    <div className="codetailsection  mt-3">
                        <div className="fs-20 fw-600">{coordinators.coordinatorName || ""}</div>
                        <div className="d-flex flex-wrap gap-5 py-3">
                            <div className="d-flex gap-1">
                                <div className="fs-16 fw-500">
                                    Email :
                                </div>
                                <div className="fs-16 blue fw-500">
                                    {coordinators.coordinatorEmail || ""}
                                </div>
                            </div>
                            <div className="d-flex gap-1">
                                <div className="fs-16 fw-500">
                                    Mobile No :
                                </div>
                                <div className="fs-16 blue fw-500">
                                    {coordinators.coordinatorMobile || ""}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5 " >
                        <div className="row transactioncardsresponsive ">
                            <div className="col-md-3 ">
                                <div className="transaction-cards  py-3 px-3">
                                    <h3 className="fs-16 greyish fw-500">Total Amount Earned</h3>
                                    <div className=" d-flex align-items-center justify-content-between ">
                                        <div>
                                            <h2 className="fs-32 fw-700 blue mb-0"><span className="fs-30  blue fw-600">₹</span>&nbsp;{coordinators.totalAmtEarned}</h2>
                                        </div>
                                        <div className="totalamount-image-background">
                                            <Image src={SvgImages.amount} style={{ width: 30, aspectRatio: 1 }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="transaction-cards  py-3 px-3">
                                    <h3 className="fs-16 greyish fw-500">Paid Amount</h3>
                                    <div className=" d-flex align-items-center justify-content-between ">
                                        <div>
                                            <h2 className="fs-32 fw-700 blue mb-0"><span className="fs-30  blue fw-600">₹</span>&nbsp;{coordinators.paymentDone}</h2>
                                        </div>
                                        <div className="receivedamount-image-background">
                                            <Image src={SvgImages.received} style={{ width: 30, aspectRatio: 1 }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="transaction-cards  py-3 px-3">
                                    <h3 className="fs-16 greyish fw-500">Balance</h3>
                                    <div className=" d-flex align-items-center justify-content-between ">
                                        <div>
                                            <h2 className="fs-32 fw-700 blue mb-0"><span className="fs-30  blue fw-600">₹</span>&nbsp;{coordinators.balanceLeft}</h2>
                                        </div>
                                        <div className="balanceamount-image-background">
                                            <Image src={SvgImages.balance} style={{ width: 30, aspectRatio: 1 }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="detailspurchasepckg pt-4">
                        <div className="" style={{ display: "block" }}>

                            <div className=" row table_title">
                                <div className="col-md-7 col-12">
                                    <h1 className="black fs-18 fw-600 mb-0">Request List</h1>
                                </div>
                            </div>

                            <div style={{ overflowX: "auto" }}>
                                <table
                                    className="table mb-0"
                                    id="dtHorizontalExample"
                                    cellSpacing="0"
                                    width="100%"
                                >
                                    <thead>
                                        <tr className="table_heading">
                                            <th scope="col" style={{ width: "10%" }}>
                                                Sr No.
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Request Date
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Request Amount
                                            </th>
                                            <th className="text-center" scope="col" style={{ width: "20%" }}>
                                                Status
                                            </th>
                                            <th className="text-center" scope="col" style={{ width: "15%" }}>
                                                Payout
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg_light">
                                        {Withdrawl?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{limit * offset + (index + 1)}</td>
                                                <td className="text-start">{removeTimeFromDate(item.create_date)}</td>
                                                <td className="text-start">{item.amount}</td>
                                                <td >{item.status === "approved" ? <div className="text-center green text-capitalize">{item.status}</div> : <div className="text-center orange text-capitalize">{item.status}</div>}</td>
                                                <td className="text-center">
                                                    <a
                                                        className="cursor-pointer " style={{ textDecoration: 'underline' }}
                                                        onClick={() =>{

                                                            const coordinatorPrivilege = user?.setPrivileges?.find(
                                                                (priv) => priv.parameter === "Coordinator"
                                                              );
                                                              if (!coordinatorPrivilege?.update) {
                                                               
                                                                toast.warning("You don't have permission for payout.");
                                                                return;
                                                              }
                                                            
                                                            { setShowAddModal(true), setRequestId(item.request_id), setRequestAmount(item.amount) }}}
                                                    >
                                                        Pay Now
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>

                                </table>


                            </div>
                            {generatePaginationFooter(
                                availableDataCount,
                                limit,
                                offset,
                                setOffset
                            )}
                        </div>




                        <div className="mt-5" style={{ display: "block" }}>

                            <div className=" row table_title align-items-center responsivetablepackagetwo">

                                <div className="col-md-3 col-12">
                                    <h1 className="black fs-18 fw-600 mb-0">Payout History</h1>
                                </div>
                                <div className="col-md-9 col-12 d-flex gap-2 align-items-center sectionPayouts justify-content-end datepickerstyle">
                                    <div className="">Date:</div>
                                    <div >
                                        <DatePicker
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            selectsStart
                                            startDate={startDate}
                                            endDate={endDate}
                                            dateFormat="yyyy-MM-dd"
                                            isClearable
                                            placeholderText="From"
                                            maxDate={new Date()}
                                            customInput={<CustomDateInput />}
                                        />
                                    </div>
                                    <div >
                                        <DatePicker
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            selectsEnd
                                            startDate={startDate}
                                            endDate={endDate}
                                            dateFormat="yyyy-MM-dd"
                                            isClearable
                                            placeholderText="To"
                                            minDate={startDate}
                                            maxDate={new Date()}
                                            customInput={<CustomDateInputTo />}
                                        />
                                    </div>
                                    <div className="responsivepayout col-lg-4 col-md-6 col-sm-7" >
                                        <CustomDropDown

                                            placeholder="Commission Earned"
                                            name="medium"
                                            id="medium"
                                            labelClass='commissionsection'
                                            Dropdownclass="marginsection"
                                            // setResetValue={setResetMedium}
                                            // resetValue={resetMedium}
                                            inputType={InputType.text}
                                            // showError={errorsStepOne?.medium}
                                            // errorMessage={errorsStepOne?.medium?.message}
                                            // setValue={setValuesStepOne}
                                            options={DataProvider.commissionEarned}
                                        // defaultOption={() => {
                                        //   return question.medium
                                        //     ? { value: question.medium, label: question.medium }
                                        //     : null;
                                        // }}
                                        />
                                    </div>
                                    <div className="">
                                        <ButtonWithIcon
                                            text={"Export"}
                                            icon={PngImages.xlspic}
                                            onClick={handleExportClick}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div style={{ overflowX: "auto" }}>
                                <table
                                    className="table mb-0"
                                    id="dtHorizontalExample"
                                    cellSpacing="0"
                                    width="100%"
                                >
                                    <thead>
                                        <tr className="table_heading">
                                            <th scope="col" style={{ width: "10%" }}>
                                                Sr No.
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Request Date
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Request Amount
                                            </th>
                                            <th scope="col" style={{ width: "20%" }}>
                                                Status
                                            </th>
                                            <th scope="col" style={{ width: "15%" }}>
                                                Paid Amount
                                            </th>
                                            <th scope="col" style={{ width: "15%" }}>
                                                Paid Date
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Mode of Payment
                                            </th>
                                            <th scope="col" style={{ width: "10%" }}>
                                                Transaction ID
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg_light">
                                        {transactiondata?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{limit * offset + (index + 1)}</td>
                                                <td className="white-space">{removeTimeFromDate(item.requestCreateDate)}</td>
                                                <td className="">{item.amountRequested}</td>
                                                <td className=" green text-capitalize"> {item.status}</td>
                                                <td>{item.amountPaid}</td>
                                                <td className="white-space">{removeTimeFromDate(item.paidDate)}</td>
                                                <td className="green">{item.modeOfPayment}</td>
                                                <td>{item.transactionId}</td>

                                            </tr>
                                        ))}

                                    </tbody>

                                </table>

                            </div>

                            {generatePaginationFooter(
                                availableDataCount2,
                                limit2,
                                offset2,
                                setOffset2
                            )}
                        </div>
                    </div>
                </div>

            </div>
            <FormModal
                showModal={showAddModal}
                submitButtonText="Submit"
                submitButtonIcon={SvgImages.right_arrow}
                extraclass="imgmargin"
                setShowModal={setShowAddModal}
                submitClickAction={handleSubmitAdd(Paynow)}
                children={
                    <form onSubmit={
                        handleSubmitAdd(Paynow)
                    }>

                        {/* Custom DropDown for Class Selection */}
                        <CustomTextField
                            labelTitle="Amount"
                            placeholder="Amount"
                            name="amount"
                            id="amount"
                            showError={errorsStepOne?.amount}
                            errorMessage={errorsStepOne?.amount?.message}
                            setValue={setValuesStepOne}
                            register={registerStepOne}
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                        />

                        <CustomTextField
                            labelTitle="Transaction ID"
                            placeholder="Transaction ID"
                            name="transactionid"
                            id="transactionid"
                            showError={errorsStepOne?.transactionid}
                            errorMessage={errorsStepOne?.transactionid?.message}
                            setValue={setValuesStepOne}
                            register={registerStepOne}
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                        // options={
                        //   classes.map((e) => { return { value: e._id, label: e.class_name } })
                        // }
                        // defaultOption={() => {
                        //   setEditValue("class", editData.class_id, { shouldValidate: true });
                        //   return { value: editData.class_id, label: editData.class_name }
                        // }}
                        />
                        <CustomDropDown
                            labelTitle="Mode"
                            placeholder="Select"
                            name="modeofpayment"
                            id="modeofpayment"
                            showError={errorsStepOne?.modeofpayment}
                            errorMessage={errorsStepOne?.modeofpayment?.message}
                            setValue={setValuesStepOne}
                            register={registerStepOne}
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            options={DataProvider.mode}
                            defaultOption={{ value: 'Bank Transfer', label: 'Bank Transfer' }}

                        />


                    </form>
                }
            />

        </div>
    );
};

export default CoordinatorPayout;
